<template>
  <div id="choices">
    <ChoiceNavigation></ChoiceNavigation>
    <br>
    <Datatable
      v-if="inventory"
      entity="choice"
      class="datatable"
      ref="datatable"
      :parameters="{inventory: inventory.id}"
      :onRowClick="onRowClick"
      :globalActions="[
        {text: 'choices.new', method: onCreate, condition: function() { return $store.getters.loggedUserCanModifyInventory }},
        {text: 'display_priority', method: goToDisplayPriority, condition: function() { return $store.getters.loggedUserCanModifyInventory }}]"
      :rowActions="[
        {text: 'datatable.edit', method: onRowEdit},
        {text: 'datatable.delete', method: onRowDelete, condition: function() { return $store.getters.loggedUserCanModifyInventory }}
      ]">
    </Datatable>

    <Modal
      name="delete-confirmation"
      :title="$t('categories.confirmation')"
      dismissable
      :actions="[{name: $t('back'), action: 'close'}, {name: $t('datatable.delete'), action: deleteChoiceAction, primary: true}]">
      <p>{{$t('choices.delete_message')}} <b>{{actionRow.name}}</b>?</p>
    </Modal>

  </div>
</template>

<script>

  import Datatable from "@/components/Datatable.vue";
  import ChoiceNavigation from '@/components/choices/Navigation.vue';
  import { mapActions } from "vuex";

  export default {
    name: "choices",

    components: { ChoiceNavigation, Datatable },

    data() {
      return {
        actionRow: { },
        entityName: 'choices'
      }
    },

    computed: {
      inventory() {
        return this.$store.state.contextInventory
      }
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "inventory.choices";
      this.$store.state.pageIcon = "/icon/menu.svg";
    },

    methods: {

      ...mapActions(["deleteInventoryEntity"]),

      edit(id) {
        this.$router.push({ path: '/choices/edit', query : Object.assign({ id : id, inventory: this.inventory.id }, this.$route.query) });
      },
      onCreate() {
        this.edit(null)
      },
      onRowClick(row) {
        this.edit(row.id);
      },
      onRowEdit(row) {
        this.edit(row.id)
      },
      onRowDelete(row) {
        this.actionRow = row;
        this.$modal.show("delete-confirmation");
      },
      goToDisplayPriority() {
        this.$router.push({ path: '/choice/priority', query : Object.assign({inventory: this.inventory.id }, this.$route.query) });
      },
      async deleteChoiceAction() {
        this.$store.commit("showSpinner", true);
        let response = await this.deleteInventoryEntity({ entity: this.entityName, inventory: this.inventory.id, id: this.actionRow.id });
        if (response) {
          this.$modal.show("delete-confirmation", false);
          this.$refs.datatable.query();
          this.$store.commit("showSpinner", false);
        } else {
          this.$modal.show("delete-confirmation", false);
          toast(this.$t("error.no_server"),"error");
          this.$store.commit("showSpinner", false);
        }
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
